require('./hireCardMaestroSuccess.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');
const { getLastNChars } = require('utilities/stringHelper');
const HireSuccessStepCardImage = require('components/cards/hireSuccessStepCardImage/hireSuccessStepCardImage');

//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');

// @ components
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';

// @ constants
const { ACCIDENTS_INSURANCE } = require('constants/flagBasedFeatures');

class hireCardMaestroSuccess extends React.Component {

    buildSummary() {
        const {
            immAccount,
            immHireCardNameSelector,
        } = this.props;

        const accountIban = getLastNChars(immAccount.get('iban'));

        return (
            <div className="row hire-card-maestro-success__summary">
                <div className="col-xs-6">
                    <FormattedText
                        className="col-xs-12 hire-card-maestro-success__summary-title"
                        value="hireCardMaestro-summarySelectedName"
                    />
                    <div className="col-xs-12 hire-card-maestro-success__summary-value">
                        {immHireCardNameSelector.getIn(['names', immHireCardNameSelector.get('selectedIndex')])}
                    </div>
                </div>
                <div className="col-xs-6">
                    <FormattedText
                        className="col-xs-12 hire-card-maestro-success__summary-title"
                        value="hireCardMaestro-summarySelectedAccount"
                    />
                    <div className="col-xs-12 hire-card-maestro-success__summary-value">
                        {`${immAccount.get('alias')} ${accountIban}`}
                    </div>
                </div>
            </div>
        );
    }

    buildMessage() {
        const { immProfile } = this.props;
        const email = PersonalDataHelper.getEmail(immProfile);
        const text = !!email ? 'hireCardMaestro-successWarningTextSentByEmail' : 'hireCardMaestro-successWarningTextUpdateEmail';
        const injectedString = [
            ...(!!email ? [email] : [])
        ];

        return (
            <div className="hire-card-maestro-success__message">
                <OKMessage type="informative">
                    <FormattedText value={text} injectedStrings={injectedString} />
                </OKMessage>
            </div>
        );
    }

    render() {
        const {
            immHireCardImageSelector,
            immProfile,
            immShippingAddress,
            originCountry,
            processDetail
        } = this.props;
        let content;

        if (immProfile.get('isFetching')) {
            content = <LoadingSection />;
        } else {
            const messageSection = this.buildMessage();
            const summarySection = this.buildSummary();
            const address = PersonalDataHelper.getHireFormattedShippingAddress(immShippingAddress, originCountry);
            const selectedImageId = immHireCardImageSelector.get('selectedImageId');
            const immImageData = immHireCardImageSelector.getIn(['imagesById', selectedImageId]);
            const goBackButton = {
                label: (
                    <FormattedText
                        format="uppercase"
                        value="hireCardMaestro-successBackButtonText"
                    />
                ),
                url: '/myprofile/cards'
            };
            const url = formatText('hireCardMaestro-successWarningUrl2');
            content = (
                <WizardSuccess
                    mainButton={goBackButton}
                    processDetail={processDetail}
                    successMessage={formatText('hireCardMaestro-successTitle')}
                >
                    <article className="hire-card-maestro-success">
                        <div className="row">
                            
                            <HireSuccessStepCardImage
                                className="col-xs-4 hire-card-maestro-success__card-image"
                                immImageData={immImageData}
                            />
                            <div className="col-xs-8 hire-card-maestro-success__text">
                                <FormattedText value="hireCardMaestro-successAddressText1" />
                                <div className="hire-card-maestro-success__address">
                                    <i className="hire-card-maestro-success__address-icon icon icon-s-locacion" />
                                    {address}
                                </div>
                            </div>
                        </div>
                        {summarySection}
                        <FeatureTogglingRender notAllowedProductKey={ACCIDENTS_INSURANCE} >
                            <div className="hire-card-maestro-success__message">
                                <OKMessage type="informative">
                                    <FormattedText value="hireCardMaestro-successWarningText1" />
                                    &nbsp;
                                    <OKLink modifier="inline" target="_blank" to={url}>
                                        <FormattedText value="hireCardMaestro-successWarningText2" />
                                    </OKLink>
                                    &nbsp;
                                    <FormattedText value="hireCardMaestro-successWarningText3" />
                                </OKMessage>
                            </div>
                        </FeatureTogglingRender>
                        {messageSection}
                    </article>
                </WizardSuccess>
            );
        }
        return content
    }
}

hireCardMaestroSuccess.propTypes = {
    immAccount: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
    immHireCardMaestro: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immShippingAddress: PropTypes.object.isRequired,
    originCountry: PropTypes.string.isRequired,
    processDetail: PropTypes.string
};

module.exports = hireCardMaestroSuccess;
